<template>
  <v-container>
    <h1>Смета №{{ estimate.id }}</h1>

    <v-card class="mt-5" v-if="!hideSiteBlock">
      <v-card-title>Вывод на сайте</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Название сметы"
              v-model="name"
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Название категории смет"
              v-model="categoryName"
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="d-flex">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="$emit('save', { name, categoryName })">Сохранить</v-btn>
            <v-spacer></v-spacer>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mt-5">
      <v-card-title>Информация по объекту</v-card-title>
      <v-card-text>
        <p>Тип объекта: {{ estimate.objectEntity.objectType }}</p>
        <p>Адрес объекта: {{ estimate.objectEntity.addressPublic }}</p>
        <p>Этаж: {{ estimate.objectEntity.floor }}</p>
        <p>Есть лифт: {{ estimate.objectEntity.isElevatorEnable ? 'да' : 'нет' }}</p>
        <p>Высота потолков: {{ estimate.objectEntity.height }} м</p>
        <p>
          <span class="subtitle-2">Комнаты</span>
          <v-data-table 
            :items="rooms"
            :headers="roomHeaders"
            hide-default-footer
            disable-pagination
          ></v-data-table>
        </p>
      </v-card-text>
    </v-card>

    <v-card class="mt-5 mb-5" v-if="price">
      <v-card-text>
        <v-tabs v-model="tab"
          
        >
          <v-tab href="#tab1">Работы</v-tab>
          <v-tab>Черновые материалы</v-tab>
          <v-tab>Чистовые материалы</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item value="tab1">
            <v-data-table
              :items="services"
              :headers="servicesHeaders"
              disable-pagination
              hide-default-footer
            >
              <template v-if="services.length > 0" v-slot:body="{ items }">
                <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <td :colspan="item.tp == 'service' ? 1 : ((item.tp == 'final' || item.tp == 'stageFinal') ? 4 : 5)">
                      <template v-if="item.tp == 'stage'"><h2>{{ item.name }}</h2></template>
                      <template v-else-if="item.tp == 'category'"><h3>{{ item.name }}</h3></template>
                      <template v-else-if="item.tp == 'subCategory'"><h4>{{ item.name }}</h4></template>
                      <template v-else-if="item.tp == 'final' || item.tp == 'stageFinal'">
                        <div style="text-align: right;">
                          <strong>{{ item.name }}</strong>
                        </div>
                      </template>
                      <template v-else>{{ item.name }}</template>
                    </td>
                    <td v-if="item.tp == 'service'">
                      {{ item.unitName }}
                    </td>
                    <td v-if="item.tp == 'service'">
                      {{ item.pricePerUnit }}
                    </td>
                    <td v-if="item.tp == 'service'">
                      {{ item && item.value ? item.value.toFixed(2) : 'N/A' }}
                    </td>
                    <td v-if="item.tp == 'service' || item.tp == 'final' || item.tp == 'stageFinal'">
                      {{ item && item.cost ? item.cost.toFixed(2) : 'N/A' }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item>
            <materials-list 
              :price="price"
              :materials="estimate.materials.defaults"
            ></materials-list>
          </v-tab-item>
          <v-tab-item>
            <materials-list 
              :price="price"
              :materials="estimate.materials.selected"
            ></materials-list>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
    
  </v-container>
</template>

<script>
import { transliterate as tr, slugify } from 'transliteration';
import MaterialsList from './EstimateMaterialsList';

export default {
  props: {
    estimate: Object,
    price: Object,
    hideSiteBlock: Boolean
  },

  components: {
    MaterialsList
  },
  
  data() {
    //console.log(this.estimate);
    return {
      componentId: this.getTempId(),
      name: this.estimate.name,
      tag: this.estimate.tag,
      categoryName: this.estimate.categoryName,
      tab: 'tab1',
      roomHeaders: [
        {
          text: 'Название',
          value: 'name'
        },
        {
          text: 'Площадь пола (м²)',
          value: 'floor_square'
        },
        {
          text: 'Площадь стен (м²)',
          value: 'walls_square'
        },
        {
          text: 'Периметр пола (м)',
          value: 'floor_perimeter'
        },
        {
          text: 'Длина откосов (м)',
          value: 'slopes_length'
        }
      ],
      servicesHeaders: [
        {
          text: 'Наименование',
          value: 'name'
        },
        {
          text: 'Ед.изм.',
          value: 'unitName'
        },
        {
          text: 'Цена за ед.',
          value: 'pricePerUnit'
        },
        {
          text: 'Кол-во',
          value: 'value'
        },
        {
          text: 'Стоимость',
          value: 'cost'
        }
      ],
    }
  },

  methods: {
    generateTag() {
      this.tag = slugify(this.name);
    },

    getMaterialsList() {

    },
  },
  
  computed: {
    rooms() {
      return [
        ...this.estimate.objectEntity.rooms.map(x => ({
          name: x.name,
          floor_square: x.finalParams.floor_square.toFixed(2),
          walls_square: x.finalParams.walls_square.toFixed(2),
          floor_perimeter: x.finalParams.floor_perimeter.toFixed(2),
          slopes_length: x.finalParams.slopes_length.toFixed(2),
        })),
        {
          name: 'ИТОГО ПО ОБЪЕКТУ',
          floor_square: this.estimate.objectEntity.rooms.reduce((sum, cur) => sum + Number(cur.finalParams.floor_square), 0).toFixed(2),
          walls_square: this.estimate.objectEntity.rooms.reduce((sum, cur) => sum + Number(cur.finalParams.walls_square), 0).toFixed(2),
          floor_perimeter: this.estimate.objectEntity.rooms.reduce((sum, cur) => sum + Number(cur.finalParams.floor_perimeter), 0).toFixed(2),
          slopes_length: this.estimate.objectEntity.rooms.reduce((sum, cur) => sum + Number(cur.finalParams.slopes_length), 0).toFixed(2),
        }
      ];
    },

    services() {
      let servicesList = this.estimate.services.map(serv => {
        let item = this.price.services.find(x => x.name == serv.original.trim());
        let itemIndex = this.price.services.findIndex(x => x.name == serv.original);
        if (item) {
          if (item.stages.length == 0) {
            console.log('Не найден этап:' + serv.original);
            return {};
          }
          let stage = this.price.stages.find(x => String(x._id) == item.stages[0]);
          return {
            ...item,
            value: serv.value,
            cost: serv.value * item.pricePerUnit,
            stage: stage ? stage.name : 'N/A',
            stageIndex: this.price.stages.findIndex(x => String(x._id) == item.stages[0]),
            itemIndex
          }
        } else {
          console.log('Работа не найдена:' + serv.original + '/');
          return {};
        }
      });
      servicesList.sort((a, b) => a.stageIndex < b.stageIndex || 
        (a.stageIndex == b.stageIndex && a.itemIndex < b.itemIndex) ? -1 : 1);
      let items = [];
      let prev = null;
      let stageNumber = 1;
      //console.log(services);
      for (let serv of servicesList) {
        //console.log(serv);
        if (!prev || prev.stage != serv.stage) {
          if (prev && prev.stage != serv.stage) {
            // Вставляем ИТОГО по этапу
            items.push({
              tp: 'stageFinal',
              name: `ИТОГО (${prev && prev.stage ? prev.stage.toUpperCase() : 'N/A'}):`,
              cost: servicesList.filter(x => x.stage == prev.stage).reduce((sum, cur) => sum + cur.cost, 0),
              id: this.getTempId()
            });
          }
          items.push({
            tp: 'stage',
            name: 'ЭТАП ' + (stageNumber++) + ': ' + (serv && serv.stage ? serv.stage.toUpperCase() : ''),
            id: this.getTempId()
          });
        }
        if (!prev || prev.categoryName != serv.categoryName) {
         items.push({
           tp: 'category',
           name: serv.categoryName,
           id: this.getTempId()
         }); 
        }
        if (!prev || prev.categoryName != serv.categoryName || prev.subCategoryName != serv.subCategoryName) {
          items.push({
           tp: 'subCategory',
           name: serv.subCategoryName,
           id: this.getTempId()
         }); 
        }
        items.push({
          tp: 'service',
          ...serv,
          id: this.getTempId()
        });
        
        prev = serv;
      }
      if (prev) {
        items.push({
          tp: 'stageFinal',
          name: `ИТОГО (${prev && prev.stage ? prev.stage.toUpperCase() : 'N/A'}):`,
          cost: servicesList.filter(x => x.stage == prev.stage).reduce((sum, cur) => sum + cur.cost, 0),
          id: this.getTempId()
        });
        items.push({
          tp: 'final',
          name: 'ИТОГО (ПО ВСЕМ ЭТАПАМ):',
          cost: servicesList.reduce((sum, cur) => sum + cur.cost, 0),
          id: this.getTempId()
        });
      }
      
      return items;
    },
  }
}
</script>